import * as Sentry from '@sentry/browser';
import { DoneInvokeEvent } from 'xstate';
import { defaultStackParser, makeFetchTransport } from '@sentry/react';
import { Breadcrumb } from '@sentry/types';
import config from '../config';

type IEnv = 'local' | 'staging' | 'prod';

const configGenerator = () => {
  let environment: IEnv | undefined;
  let release: string | undefined;
  try {
    environment ??= process.env.REACT_APP_ENV as IEnv;
    release ??= process.env.REACT_APP_RELEASE as string;
  } catch {
    console.error('sentry configGenerator error');
  }
  return { environment, release };
};

const client = new Sentry.BrowserClient({
  transport: makeFetchTransport,
  stackParser: defaultStackParser,
  dsn: config().SENTRY_DSN,
  normalizeDepth: 10,
  environment: configGenerator().environment || 'production',
  release: configGenerator().release || undefined,
  integrations: [...Sentry.defaultIntegrations],
});
export const SentryHub = new Sentry.Hub(client);

Sentry.makeMain(SentryHub);

export const SentryTrackingFn = (event: DoneInvokeEvent<any>, context:any, name:string, level: 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug') => {
  SentryHub.withScope(() => {
    SentryHub.setContext(`${name}-context`, context);
    SentryHub.captureMessage(name, level);
  });
};

export const SentryBreadcrumb = ({ type, level, event_id, category, message, data }:Breadcrumb) => {
  SentryHub.addBreadcrumb({
    type,
    level,
    event_id,
    category,
    message,
    data,
  });
};
